var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagFr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 400,
    viewBox: "0 0 600 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_556_1460)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_556_1460",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 600,
    height: 400
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M557.143 0H42.8571C19.1878 0 0 17.9086 0 40V360C0 382.091 19.1878 400 42.8571 400H557.143C580.812 400 600 382.091 600 360V40C600 17.9086 580.812 0 557.143 0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_556_1460)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M557.143 5.00049H42.8574C22.1467 5.00049 5.35742 20.6705 5.35742 40.0005V360C5.35742 379.33 22.1467 395 42.8574 395H557.143C577.854 395 594.643 379.33 594.643 360V40.0005C594.643 20.6705 577.854 5.00049 557.143 5.00049Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 14.2857
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_556_1460",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: -3,
    width: 604,
    height: 406
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M557.143 5.00049H42.8574C22.1467 5.00049 5.35742 20.6705 5.35742 40.0005V360C5.35742 379.33 22.1467 395 42.8574 395H557.143C577.854 395 594.643 379.33 594.643 360V40.0005C594.643 20.6705 577.854 5.00049 557.143 5.00049Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 14.2857
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_556_1460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600 0H400V400H600V0Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 400H200V0H0V400Z",
    fill: "#0A17A7"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_556_1460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    rx: 43,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagFr);
export default __webpack_public_path__ + "static/media/flag_fr.e43fc49a03c2bf2a2955bd757c21c7d3.svg";
export { ForwardRef as ReactComponent };